import * as React from 'react';
import {FunctionComponent} from 'react';
import {Text} from 'spectacle';

interface OwnProps {}

export const Footnote: FunctionComponent<OwnProps> = ({children}) => {
    return (
        <Text textColor="tertiary" textAlign="right" textSize="14px" padding={0} margin="20px 0 0 0">
            {children}
        </Text>
    );
};
